export default "__VITE_ASSET__BHo9HUeW__$_?react__"